export default __webpack_public_path__ + "static/media/combot-black.01e6a364.svg";